export enum SMSType {
  Confirmation = 1,
  Reminder = 2,
  PaymentLink = 3,
  Custom = 4,
}
